/* @flow */
import * as React from "react";

import dataLayer from "../common/dataLayer";
import type { Dispatch } from "../../redux/action";
import type { State as Settings } from "../../redux/reducer/settings";

import * as Tools from "./Tools";
import { gaReducer } from "../GA";

type Props = {
  activeTool: any,
  dispatch: Dispatch,
  settings: Settings,
  isMobile?: boolean,
  handlePopupOpen: (key: string) => void
};

export default function ToolsActive(props: Props) {
  function updateSettings(payload) {
    props.dispatch({ type: "UPDATE_SETTINGS", payload });
  }

  let tool = null;

  switch (props.activeTool) {
    case "chartType":
      tool = (
        <Tools.SwitchChartType
          value={props.settings.chartType}
          onChange={chartType => updateSettings({ chartType })}
          animated={props.settings.animatedChart === undefined ? true : props.settings.animatedChart}
          onChangeAnimated={animatedChart => updateSettings({ animatedChart })}
        />
      );
      break;
    case "lineThickness":
      tool = (
        <Tools.SwitchLineThickness
          value={props.settings.lineThickness}
          onChange={lineThickness => updateSettings({ lineThickness })}
        />
      );
      break;
    case "lineColor":
      tool = (
        <Tools.SwitchLineColor
          value={props.settings.lineColor}
          onChange={lineColor => updateSettings({ lineColor })}
        />
      );
      break;
    case "interval":
      tool = (
        <Tools.SwitchInterval
          value={props.settings.interval}
          onChange={interval => updateSettings({ interval })}
        />
      );
      break;
    case "indicators":
      tool = (
        <Tools.ActivateIndicator
          indicators={props.settings.indicators}
          handlePopupOpen={props.handlePopupOpen}
          mobile={props.isMobile}
          onToggle={index => {
            props.dispatch({
              type: "TOGGLE_INDICATOR",
              payload: index
            });
          }}
          onRemove={index => {
            props.dispatch({
              type: "REMOVE_INDICATOR",
              payload: index
            });
          }}
          key="activate"
        />
      );
      break;
    case "sentiments":
      tool = (
        <Tools.SwitchSentiments
          value={props.settings.sentiments}
          onChange={() => {
            gaReducer("CLICKBTN_MOOD", {
              value: props.settings.sentiments ? "off" : "on"
            });
            return updateSettings({ sentiments: !props.settings.sentiments });
          }
          }
        />
      );
      break;
    case "theme":
      tool = (
        <Tools.SwitchTheme
          value={props.settings.theme}
          onChange={theme => updateSettings({ theme })}
        />
      );
      break;
    case "sound":
      tool = (
        <Tools.SwitchSound
          value={props.settings.sound}
          onChange={sound => {
            dataLayer({
              event: "event-to-ga",
              eventCategory: "Sound switch",
              eventAction: `Switch: ${sound ? "on" : "off"}`,
              eventLabel: ""
            });

            gaReducer("CLICKBTN_SOUND", {
              value: sound ? "on" : "off"
            });

            updateSettings({ sound });
          }}
        />
      );
      break;
    default:
      break;
  }

  return tool;
}



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolsActive.js